export const FETCH_USER_ASSETS_FAILURE = 'FETCH_USER_ASSETS_FAILURE';
export const FETCH_USER_ASSETS_REQUEST = 'FETCH_USER_ASSETS_REQUEST';
export const FETCH_USER_ASSETS_SUCCESS = 'FETCH_USER_ASSETS_SUCCESS';

export const FETCH_USER_PNL_FAILURE = 'FETCH_USER_PNL_FAILURE';
export const FETCH_USER_PNL_REQUEST = 'FETCH_USER_PNL_REQUEST';
export const FETCH_USER_PNL_SUCCESS = 'FETCH_USER_PNL_SUCCESS';

export const FETCH_USER_PNL_EXPECTED_FAILURE = 'FETCH_USER_PNL_EXPECTED_FAILURE';
export const FETCH_USER_PNL_EXPECTED_REQUEST = 'FETCH_USER_PNL_EXPECTED_REQUEST';
export const FETCH_USER_PNL_EXPECTED_SUCCESS = 'FETCH_USER_PNL_EXPECTED_SUCCESS';